module.exports = __webpack_public_path__ + "static/mdg-040f54e2f6c858e0a3dcf568c3f2b6f1.png";